export const clusterSteps = [
 {
  label: "cluster.add.serverName",
  description: "cluster.add.serverNameDescription"
 }
];

export const clusterAppSteps = [
 {
  label: "docker.website.add.siteName",
  description: "cluster.add.siteNameMessage"
 },
 {
  label: "docker.website.add.appVersion",
  description: "docker.website.add.appVersionMessage"
 },
 {
  label: "cluster.add.setReplicas",
  description: "cluster.add.setReplicasMessage"
 }
];

export const webAppWizardCluster = [
 {
  type: "php",
  icon: "PhpIcon",
  title: "cluster.add.phpTitle",
  subtitle: "cluster.add.phpSubtitle",
  section: "custom"
 }
];

export const dbSteps = [
 {
  label: "cluster.add.serverDbName",
  description: "cluster.add.serverDbNameDescription"
 }
];
